import type { PendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import { getSafeGateway } from '@tectonics/prs/core/gateway';

export function getGatewayVoucherUrl(incomingPayment: PendingIncomingPayment): string {
  const gateway = getSafeGateway(incomingPayment);
  return gateway['voucher_url'];
}
